import { render, staticRenderFns } from "./coupon-summary.vue?vue&type=template&id=713f822c&"
import script from "./coupon-summary.vue?vue&type=script&lang=js&"
export * from "./coupon-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports